export const CREATORS = ['jmlll15', 'jmlll15_2'] as const
export type CREATOR = (typeof CREATORS)[number]

export const creatorMapTargetId: Record<CREATOR, string> = {
  jmlll15: 'codMw2_1',
  jmlll15_2: 'codMw2_2',
}

export const mapCodMw2CreatorInfo: Record<
  CREATOR,
  {
    profileCardImageURL: string
  }
> = {
  jmlll15: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['jmlll15']}/0.jpeg`,
  },
  jmlll15_2: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['jmlll15_2']}/0.jpeg`,
  },
}
